import { useState } from 'react'

export const useUpsellTray = ({
  itinerary,
  onListingItemSelect,
  fetchUpsellTrayOptions,
  errorLogUpsellCallListings,
}) => {
  const [isUpsellTrayOpen, setIsUpsellTrayOpen] = useState(false)
  const [isLoadingUpsells, setIsLoadingUpsells] = useState(true)
  const [isErrorLoadingUpsells, setIsErrorLoadingUpsells] = useState(false)
  const [upsells, setUpsells] = useState([])

  const onShowAddons = async (e) => {
    e.stopPropagation()
    setIsUpsellTrayOpen(true)
    if (!isErrorLoadingUpsells && upsells.length === 0) {
      try {
        const upsells = await fetchUpsellTrayOptions({ itinerary })
        setIsLoadingUpsells(false)
        setUpsells(upsells)
      } catch (e) {
        setIsLoadingUpsells(false)
        setIsErrorLoadingUpsells(true)
        if (errorLogUpsellCallListings) {
          errorLogUpsellCallListings(e)
        }
      }
    }
  }

  const onHideAddons = (e) => {
    e.stopPropagation()
    setIsUpsellTrayOpen(false)
  }

  const handleUpsellOptionClick = (e, priceKey) => {
    e.stopPropagation()
    itinerary.priceKey = priceKey
    onListingItemSelect({ itinerary, id: priceKey })
  }

  return {
    isUpsellTrayOpen,
    isLoadingUpsells,
    isErrorLoadingUpsells,
    upsells,
    onShowAddons,
    onHideAddons,
    handleUpsellOptionClick,
  }
}
